import { Button } from "@mui/material";
import { styleHelper } from "../../shared/helpers/styleHelper";

interface ButtonPrimaryProps {
  onClick(): void;
  text: string;
}

const ButtonPrimary = ({ onClick, text }: ButtonPrimaryProps) => {
  return (
    <div>
      <Button style={styleHelper.button} variant="contained" onClick={onClick}>
        {text}
      </Button>
    </div>
  );
};

export default ButtonPrimary;
